const formatPhone = (phone) => {
  if (phone && phone.length === 10) {
    return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6, 10)}`
  } else {
    return phone
  }
}

export {
  formatPhone,
}
